export default "__VITE_ASSET__DECipHQs__"